import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth-guard.guard';
import { noAuthGuard } from './core/auth/guards/no-auth-guard.guard';
import { forcedLogoutGuard } from './core/auth/guards/forced-logout.guard';
import { publicGuard } from './core/auth/guards/public.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'get-qr-order-details/:orderId/:dropId',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./modules/get-qr-order-details/get-qr-order-details.component').then(
        (m) => m.GetQrOrderDetailsComponent,
      ),
  },
  {
    path: 'distribution-partner/order-details',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./modules/distribution-partner/distribution-partner.component').then(
        (m) => m.DistributionPartnerComponent,
      ),
  },
  {
    path: 'driver-partner/order-detail',
    loadComponent: () =>
      import('./modules/driver-partner/driver-partner.component').then(
        (m) => m.DriverPartnerComponent,
      ),
  },
  {
    path: 'inter-regional-order-tracking/order-details',
    loadComponent: () =>
      import('./modules/order-tracking/order-tracking.component').then(
        (m) => m.OrderTrackingComponent,
      ),
  },
  {
    path: 'inter-state-order-tracking/order-details',
    loadComponent: () =>
      import('./modules/order-tracking/order-tracking.component').then(
        (m) => m.OrderTrackingComponent,
      ),
  },
  {
    path: 'inter-regional-drop-tracking/order-details',
    loadComponent: () =>
      import(
        './modules/specific-order-tracking/specific-order-tracking.component'
      ).then((m) => m.SpecificOrderTrackingComponent),
  },
  {
    path: 'inter-state-drop-tracking/order-details',
    loadComponent: () =>
      import(
        './modules/specific-order-tracking/specific-order-tracking.component'
      ).then((m) => m.SpecificOrderTrackingComponent),
  },
  {
    path: 'track-order/:dropTrackId',
    canActivate: [publicGuard],
    loadChildren: () =>
      import('./modules/shopify-order-tracking/shopify-order-tracking.routes').then(
        (m) => m.routes,
      ),
  },
  {
    path: 'partner-pricing-detail',
    canActivate: [publicGuard],
    loadComponent: () =>
      import(
        './modules/shopify-app/pricing-detail/pricing-detail.component'
      ).then((m) => m.PricingDetailComponent),
    // Accessible to both authenticated and unauthenticated users.
  },
  {
    path: 'affiliate-redirection/:affiliateId',
    canActivate: [forcedLogoutGuard],
    loadComponent: () =>
      import(
        './modules/auth/affiliate-redirection/affiliate-redirection.component'
      ).then((m) => m.AffiliateRedirectionComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layout/layout.routes').then((m) => m.routes),
      },
    ],
  },
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  { path: '**', redirectTo: '/' },
];
